import { globalState } from 'helpers/store';

const sendNotification = function(payload) {
    globalState.notification.setState({
        "open": true,
        "title": payload.title,
        "description": payload.description,
        "severity": payload.severity,
        "duration": payload.duration,
    })
}
export const notify = {
    "info": (payload) => {
        payload["severity"] = "info";
        sendNotification(payload);
    },
    "success": (payload) => {
        payload["severity"] = "success";
        sendNotification(payload);
    },
    "error": (payload) => {
        payload["severity"] = "error";
        sendNotification(payload);
    },
    "warning": (payload) => {
        payload["severity"] = "warning";
        sendNotification(payload);
    }
}

